// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yNlVqKNlTFVAIdAArE6p {
  color: red;
  font-size: 0.8em;
  margin-top: 0.2em;
  margin-bottom: 0.2em; }
`, "",{"version":3,"sources":["webpack://./styles/Form.module.scss"],"names":[],"mappings":"AAAA;EACI,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB,EAAA","sourcesContent":[".form_error {\r\n    color: red;\r\n    font-size: 0.8em;\r\n    margin-top: 0.2em;\r\n    margin-bottom: 0.2em;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form_error": `yNlVqKNlTFVAIdAArE6p`
};
export default ___CSS_LOADER_EXPORT___;
